import instance from "./axiosConfig";
import { store } from "../store";
import { setAuth, clearAuth, setAuthLoading } from "../reducer/authSlice";

// Fetch logged-in user context from /v3/me. Called on app mount and after login.
// Source of truth for user data now that nothing lives in JS-accessible cookies.
export const fetchMe = async () => {
  try {
    store.dispatch(setAuthLoading(true));
    const res = await instance.get("/me");
    store.dispatch(setAuth(res.data));
    return res.data;
  } catch (err) {
    store.dispatch(clearAuth());
    return null;
  }
};

// Log out: tell backend (which clears the HttpOnly cookie) then clear Redux.
export const logoutUser = async () => {
  try {
    await instance.get("/login/logout");
  } catch (_) {
    // Non-fatal — still clear local state below.
  }
  store.dispatch(clearAuth());
};
